import type { PropsWithChildren } from 'react'
import {
  selectIsIpRestricted,
  useIpRestrictionStore,
} from '~/stores/ipRestriction/ipRestriction'
import {
  selectKioskAuthError,
  useKioskAuthErrorStore,
} from '~/stores/kioskAuthError/kioskAuthError'
import { IpRestrictionError } from '../IpRestrictionError/IpRestrictionError'
import { KioskAuthError } from '../KioskAuthError/KioskAuthError'
import { Snackbar } from '../Snackbar/Snackbar'
import { UpdateModal } from '../UpdateModal/UpdateModal'

export function GlobalLayout({ children }: PropsWithChildren) {
  // キオスク端末アカウントのトークン取得が IP アドレス制限で拒否された場合、
  // 全ルート（/login 含む）の上に全画面エラーを被せる。
  const isIpRestricted = useIpRestrictionStore(selectIsIpRestricted)
  // キオスク端末（kiosk）で認証・認可に失敗した場合の全画面エラー。
  // IP アドレス制限が検知されているときはそちらを優先し、二重に被せない。
  const kioskAuthError = useKioskAuthErrorStore(selectKioskAuthError)

  return (
    <>
      {children}
      <Snackbar />
      <UpdateModal />
      {isIpRestricted && <IpRestrictionError />}
      {!isIpRestricted && kioskAuthError !== null && <KioskAuthError />}
    </>
  )
}
